var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1626_318)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47734 4.47734 0 10 0C15.5227 0 20 4.47734 20 10C20 15.5227 15.5227 20 10 20C4.47734 20 0 15.5227 0 10ZM15.375 4.11887L11.0941 9.09503H11.0939L15.7498 15.8709H12.3256L9.19032 11.308L5.26498 15.8709H4.25049L8.73993 10.6526L4.25049 4.11887H7.67468L10.6435 8.43962L14.3606 4.11887H15.375ZM7.1887 4.88257H5.6305L12.8029 15.1419H14.361L7.1887 4.88257Z",
    fill: "#403E68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d23c69968858f092f6abbaad88b60da2.svg";
export { ForwardRef as ReactComponent };